import { useRecoilValue } from "recoil";
import {
  Wrapper,
  LoadingOverlay,
  Spinner,
  MainContent,
  MobileMainContent,
} from "./style";
import { loadingState } from "../recoil/loading.atom";
import { useSearchParams, Outlet } from "react-router-dom";
import SideBar from "./sideBar";
import { WideState } from "../recoil/wide";
import MobileSideBar from "./mobileBottom";

const Layout = () => {
  const isLoading = useRecoilValue(loadingState);
  const isWide = useRecoilValue(WideState);
  const [searchParams] = useSearchParams();
  const page = searchParams.get("page");
  const isHideMobileSideBar = page === "edit";

  return (
    <Wrapper>
      {isLoading && (
        <LoadingOverlay>
          <Spinner />
        </LoadingOverlay>
      )}
      {isWide ? (
        <MainContent>
          <div className="left">
            <SideBar />
          </div>
          <div className="right">
            <div className="content">
              <Outlet />
            </div>
          </div>
        </MainContent>
      ) : (
        <MobileMainContent>
          <div className="top">
            <div className="content">
              <Outlet />
            </div>
          </div>
          {!isHideMobileSideBar && <MobileSideBar />}
        </MobileMainContent>
      )}
    </Wrapper>
  );
};

export default Layout;
